<div class='row center-align'>
        <img class="responsive-img col m6 l4 s10 offset-m3 offset-l4 offset-s1"  src="assets/images/poolspot.png"/>
        <h5 class='col s10 offset-s1' [innerHtml]='"login.message" | translate'></h5>
</div>
